import { MapPin, Building2, ShieldCheck, Cpu, Network, Headphones } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <span className="text-xs font-mono uppercase tracking-widest text-cyan-400">About Us</span>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mt-2">Revona Services</h1>
      <p className="text-lg text-slate-300 mt-5 leading-relaxed max-w-3xl">
        Revona Services is a technology company based in Funchal, Madeira, Portugal. We build and sell
        professional AI software, computer software, networking tools and digital products, and we provide
        computer, IT, networking and 24/7 technical support services to businesses and professionals.
      </p>

      <div className="grid sm:grid-cols-3 gap-5 mt-12">
        {[[Cpu, "AI & Software", "Enterprise AI and computer software licences."], [Network, "Networking Tools", "Management, monitoring and security toolkits."], [Headphones, "24/7 Support", "Round-the-clock IT and network support."]].map(([Ic, t, d]) => (
          <div key={t} className="tactical-card p-6">
            <Ic className="w-8 h-8 text-cyan-400 mb-3" />
            <h3 className="font-display font-semibold text-white">{t}</h3>
            <p className="text-sm text-slate-400 mt-1.5">{d}</p>
          </div>
        ))}
      </div>

      <div className="tactical-card p-8 mt-12 grid sm:grid-cols-2 gap-6">
        <div>
          <h3 className="font-display font-semibold text-white flex items-center gap-2 mb-4"><Building2 className="w-5 h-5 text-cyan-400" /> Company details</h3>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><span className="text-slate-500">Business type:</span> Individual</li>
            <li><span className="text-slate-500">VAT number:</span> 328 694 647</li>
            <li><span className="text-slate-500">Email:</span> revona.eu@gmail.com</li>
            <li><span className="text-slate-500">Phone:</span> +351 913 286 138</li>
          </ul>
        </div>
        <div>
          <h3 className="font-display font-semibold text-white flex items-center gap-2 mb-4"><MapPin className="w-5 h-5 text-cyan-400" /> Location</h3>
          <p className="text-sm text-slate-300">Funchal, Madeira, Portugal</p>
          <div className="flex items-center gap-2 text-sm text-slate-300 mt-4"><ShieldCheck className="w-4 h-4 text-emerald-400" /> Secure hosted payments &amp; delivery</div>
        </div>
      </div>
    </div>
  );
}
